import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDFqmZg4khPVJron56Cyj0nfsupvBjuTAA",
  authDomain: "bilardo-skor.firebaseapp.com",
  projectId: "bilardo-skor",
  storageBucket: "bilardo-skor.firebasestorage.app",
  messagingSenderId: "413070873797",
  appId: "1:413070873797:web:9017509d95240516afccac",
  measurementId: "G-VZJ76K1SLM"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// players koleksiyonundan fullName alanlarını okur
export async function getPlayerNames() {
  try {
    console.log("Firebase bağlantısı başlanıyor...");
    const playersCol = collection(db, "players");
    console.log("Koleksiyon referansı oluşturuldu");

    const playerSnapshot = await getDocs(playersCol);
    console.log("Doküman sayısı:", playerSnapshot.size);

    let names = [];

    playerSnapshot.docs.forEach((doc, idx) => {
      const data = doc.data();
      console.log(`Doküman ${idx}:`, data);

      // fullName alanını kontrol et (yeni format)
      if (data.fullName && typeof data.fullName === "string" && data.fullName.trim() !== "") {
        names.push(data.fullName.trim());
      }
      // names alanını da kontrol et (eski format - yedek)
      else if (data.names) {
        const nameField = data.names;
        if (Array.isArray(nameField)) {
          names = names.concat(nameField);
        } else if (typeof nameField === "string" && nameField.trim() !== "") {
          const splitted = nameField.split(/[,;\s]+/).map(n => n.trim()).filter(n => n);
          names = names.concat(splitted);
        }
      }
      // name alanını da kontrol et (alternatif format)
      else if (data.name && typeof data.name === "string" && data.name.trim() !== "") {
        names.push(data.name.trim());
      }
    });

    names = Array.from(new Set(names));
    console.log("Çekilen isimler:", names);
    return names;
  } catch (error) {
    console.error("Oyuncu isimleri çekilirken HATA:", error);
    console.error("Hata kodu:", error.code);
    console.error("Hata mesajı:", error.message);
    return [];
  }
}

export { db, app };